/// <amd-module name="TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Components/ServerFingerprintCard" />
import React = require("react");
import * as Resources from "TFS/Admin/Views/ProfileSettings/SSHPublicKeysView/Resources";

import { Card } from "VSSUI/Card";
import { VssComponent } from "VSS/Platform/Layout";

export default class ServerFingerprintCard extends VssComponent<{}> {
    public render() {
        return (
            <Card className="message-card-fingerprint" contentProps={{ contentPadding: false }}>
                <div>{Resources.ServerInfo}</div>
                <div>
                    <span className="font-weight-semibold">{Resources.ServerMD5FingerprintTitle}</span>
                    {Resources.ServerMD5FingerprintValue}
                </div>
                <div>
                    <span className="font-weight-semibold"> {Resources.ServerSHA256FingerprintTitle} </span>
                    {Resources.ServerSHA256FingerprintValue}
                </div>
            </Card>
        );
    }
}
